/**
 * Input required for the post-authentication redirect.
 */
export interface PostAuthRedirectInput {
  authLink: `/${string}`;
  path?: string;
  hostname?: string;
}

export enum Runtime {
  Monkey = "Monkey",
  Console = "Console",
  OneAdmin = "OneAdmin",
  OneSupportCenter = "OneSupportCenter",
  Unknown = "Unknown",
}

export enum Region {
  us1 = "us1",
  us2 = "us2",
  au1 = "au1",
  ie1 = "ie1",
  Unknown = "Unknown",
}

export enum Environment {
  Production = "Production",
  Stage = "Stage",
  Dev = "Dev",
  Local = "Local",
}

export interface DownstreamConfiguration {
  protocol?: "http" | "https";
  api?: string;
  environment?: Environment;
  region?: string;
}

export type RuntimeEnvironment = {
  runtime: Runtime;
  environment?: Environment;
  region: Region;
};

export function runtimeToEnum(str: string): Runtime {
  switch (str) {
    case "admin":
    case "oneadmin":
    case "oneadmin.internal":
      return Runtime.OneAdmin;
    case "console":
      return Runtime.Console;
    case "monkey":
      return Runtime.Monkey;
    case "help":
      return Runtime.OneSupportCenter;
    default:
      return Runtime.Unknown;
  }
}

export function environmentToEnum(str: string): Environment {
  switch (str) {
    case "dev":
      return Environment.Dev;
    case "local":
      return Environment.Local;
    case "stage":
      return Environment.Stage;
    default:
      return Environment.Production;
  }
}

export function regionToEnum(value: string): Region {
  switch (value) {
    case "us1":
      return Region.us1;
    case "us2":
      return Region.us2;
    case "au1":
      return Region.au1;
    case "ie1":
      return Region.ie1;
    // default to us1 if no region is given.
    default:
      return Region.us1;
  }
}
